// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { EntityAttachmentsSection } from '@/components/entity-attachments-section';
import { addProjectURLLink } from '@/project/api/add-project-url-link';
import { deleteProjectFile } from '@/project/api/delete-project-file';
import { uploadProjectFile } from '@/project/api/upload-project-file';
import { useProjectFiles } from '@/project/hooks/use-project-files';
import { useProjectURLLinks } from '@/project/hooks/use-project-url-links';

interface Props {
  /** The key of the project */
  projectKey: string;
  /** The ID of the project (used for uploads) */
  projectId: string;
}

/**
 * Section component for displaying and managing files and URL links on the
 * project detail page. Rendered inline in the right column.
 */
export function ProjectAttachmentsSection(props: Props) {
  const filesData = useProjectFiles({ projectKey: props.projectKey });
  const urlLinksData = useProjectURLLinks({ projectKey: props.projectKey });

  return (
    <EntityAttachmentsSection
      entityKey={props.projectKey}
      entityId={props.projectId}
      ownerType="project"
      includeAuditNote
      filesData={filesData}
      urlLinksData={urlLinksData}
      uploadFile={uploadProjectFile}
      addURLLink={addProjectURLLink}
      deleteFile={deleteProjectFile}
      // The base project key prefix covers the project detail query as well
      // as the file and URL link queries
      queryKeysToInvalidate={[['project', props.projectKey]]}
    />
  );
}
